import { inputLayerGroups } from "fond/layers";

import { getMissingBaseDataLayerNames, hasLayerGroup } from "./dataPrepCompletion";
import { DataPrepGenerateOptions } from "./dataPrepRunParameters";

/** Reasons data prep cannot run with the given layers and generate options. */
export const getUnmetDataPrepRequirements = (layerKeys: string[], generate: DataPrepGenerateOptions): string[] => {
  const unmet: string[] = [];

  const missingLayerNames = getMissingBaseDataLayerNames(layerKeys);
  if (missingLayerNames.length > 0) {
    unmet.push(`Missing ${missingLayerNames.join(", ").toLowerCase()}`);
  }

  // Leadins are generated against the version's existing network unless underground is generated alongside them.
  const hasNetwork = hasLayerGroup(layerKeys, inputLayerGroups.inUnderground) || hasLayerGroup(layerKeys, inputLayerGroups.spanPole);
  if (generate.leadins && !generate.underground && !hasNetwork) {
    unmet.push("Leadin generation requires an underground or aerial network");
  }

  return unmet;
};
